/*
*
* File JS componente Block History
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Autoplay, EffectFade]);

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-history.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockHistory = () => {

    let sliderHistoryAll = document.querySelectorAll('.block-history');

    if (!sliderHistoryAll.length) return;

    sliderHistoryAll.forEach(el => {
        
        // let arrowPrev = el.querySelector('.swiper-button-prev');
        // let arrowNext = el.querySelector('.swiper-button-next');

        // let pagination = el.querySelector('.swiper-pagination');

        // let args = {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        //     loop: false,
        //     speed: 600,
        //     spaceBetween: 10,
        //     navigation: {
        //         nextEl: arrowNext,
        //         prevEl: arrowPrev,
        //     },
        //     pagination: {
        //         el: pagination,
        //         clickable: true,
        //         renderBullet: function (index, className) {
        //             let zero = index < 10 ? '0' : '';
        //             return '<span class="' + className + '">'+ zero + (index + 1) + "</span>";
        //         },
        //     },
        //     breakpoints: {
        //         0: {
        //             slidesPerView: 1.2
        //         },
        //         768: {
        //             slidesPerView: 2,
        //             slidesPerGroup: 2
        //         },
        //         1024: {
        //             slidesPerView: 3,
        //             slidesPerGroup: 3
        //         },
        //     },
        //     a11y: {
        //         enabled: true,
        //         prevSlideMessage: 'Previous slide',
        //         nextSlideMessage: 'Next slide',
        //         firstSlideMessage: 'This is the first slide',
        //         lastSlideMessage: 'This is the last slide',
        //         paginationBulletMessage: 'Go to slide {{index}}',
        //         notificationClass: 'swiper-notification'
        //     },
        // };

        // new Swiper(el, args);

        // NEW ------------ //

        let autoplay = 5000;
        let intervalSlide = null;
        let progressBar = el.querySelector('.block-history__progress span');
        let arrowNext = el.querySelector('.block-history__swtop .swiper-button-next');
        let arrowPrev = el.querySelector('.block-history__swtop .swiper-button-prev');

        let btmSwiper = new Swiper(el.querySelector('.block-history__swbtm'), {
            slidesPerView: 1,
            slidesPerView: 1,
            spaceBetween: 0,
            simulateTouch:false,
            allowTouchMove: false,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        let topSwiper = new Swiper(el.querySelector('.block-history__swtop'), {
            slidesPerView: 1.8,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            centeredSlides: false,
            slideToClickedSlide: true,
            speed: 1000,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 3
                }
            },
            // autoplay: {
            //     delay: autoplay,
            //     disableOnInteraction: false
            // },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            on:{
                // progress: move,
                slideChange: (swiper) => {
                    btmSwiper.slideTo(swiper.realIndex);
                }
            }
        });
        
        // function move() {
        //     let elem = progressBar; 
        //     let width = 1;
        //     let autoplayTime = autoplay / 100;

        //     clearInterval(intervalSlide);
        //     intervalSlide = setInterval(frame, autoplayTime);
            
        //     function frame() {
        //         if (width >= 100) {
        //             clearInterval(intervalSlide);
        //         } else {
        //             width++; 
        //             elem.style.width = width + '%'; 
        //             console.log(elem);
        //         }
        //     }
        // }

    });

}

export default blockHistory;

//--------------------------------------------------------------------//